import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21341f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, unref, reactive, onMounted } from 'vue';
import { GbDialog } from '@/components/GbDialog/Index';

/* APIS */
import { GetModuleChecksApi } from '@/apis/basics/modules/api';
import { ElScrollbar, ElTree, ElMessage } from 'element-plus';
import { SetRoleRelationApi, GetRoleRelationApi } from '../../../../apis/basics/roles/api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const treeRef = ref<ComponentRef<typeof ElTree>>();
const moduleTrees = ref<any[]>([]);
const formSchema = ref<any>({
	role_id: '',
	module_list: [],
});

const state = reactive({
	show: false,
	loading: false,
	title: '菜单权限配置',
});

const treeClass = (node: any) => {
	return node.module_type == 2 ? 'penultimate-node' : '';
};

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	const formData = unref(formSchema);
	const checkNodeList = unref(treeRef)?.getCheckedNodes(false, true) || [];

	formData.module_list = checkNodeList.map((node: any) => {
		return node.id;
	});

	state.loading = true;

	/* 调用接口保存数据 */
	SetRoleRelationApi(formData)
		.then((res) => {
			const { succeeded, errors } = res;
			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('操作成功');
				state.show = false;
			}
		})
		.finally(() => {
			state.loading = false;
		});
};

const load = {
	getModuleTrees: async () => {
		const { succeeded, data } = await GetModuleChecksApi();
		moduleTrees.value = succeeded ? data || [] : [];
	},
	getRoleRelationList: async (roleId: string) => {
		const { succeeded, data } = await GetRoleRelationApi(roleId);
		if (succeeded) {
			(data || []).forEach((key: string) => {
				unref(treeRef)?.setChecked(key, true, false);
			});

			// unref(treeRef)?.setCheckedKeys(data || [], false);
		}
	},
};

const exposeFuncs = {
	/* 显示对话框 */
	showDialog: (roleId: string, roleName: string) => {
		unref(formSchema).role_id = roleId;
		load.getRoleRelationList(roleId);

		state.title = `${roleName} - 菜单权限配置`;
		state.show = true;
	},
};

expose({ ...exposeFuncs });

onMounted(() => {
	load.getModuleTrees();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"680px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(state).loading,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElScrollbar), {
          "max-height": "500px",
          height: "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTree), {
              ref_key: "treeRef",
              ref: treeRef,
              "show-checkbox": "",
              "node-key": "id",
              "default-expand-all": "",
              data: moduleTrees.value,
              props: { label: 'name', children: 'childrens', class: treeClass }
            }, null, 8, ["data", "props"])
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})